const Stores = (app) => {
  app
    .post("/stores/save/:id?", async ({ api, flash, req, res }) => {
      const { body, files, params } = req;

      await api(`widget-store${params.id ? `/${params.id}` : ""}`, {
        method: params.id ? "PUT" : "POST",
        body,
        files,
      }).then((response) => {
        if (response.status === 200 || response.status === 201)
          flash("success", "Successfully saved");
        else {
          flash("error", response.statusText || "Error");
          res.refreshWith({}, { url: "back", hash: "#_" });
        }
      });

      res.refreshWith(
        { modal: "", store: "", submited: true },
        { url: "back", hash: "#_" }
      );
    })
    .get("/stores/delete/:id", async ({ api, flash, req, res }) => {
      const { id } = req.params;

      await api(`widget-store/${id}`, {
        method: "DELETE",
      });

      flash("success", "Successfully removed");

      res.backDontScroll();
    })
    .post("/stores/reorder", async ({ api, assert, flash, req, res }) => {
      const { body } = req;
      assert(
        body.orderedStores,
        400,
        "You need to provide an array with the order of the stores"
      );

      await api("widget-store-reorder", {
        method: "PUT",
        body,
      });

      flash("success", "Successfully reordered");
      res.backDontScroll();
    })

    .post("/stores/push-invite/", async ({ req, res, flash, api }) => {
      const { body } = req;
      await api(`push-invite`, {
        method: "POST",
        body,
      });

      flash("success", "Invitation sent");

      res.refreshWith(
        { modal: "", email: "" },
        { url: "/coaching-portal/store", hash: "#_" }
      );
    })

    .post("/stores/status/:id", async ({ api, assert, flash, req, res }) => {
      const {
        body: { status },
        params: { id },
      } = req;
      const verbs = {
        draft: "unpublish",
        published: "publish",
      };

      assert(status, 400, "Status is required");
      assert(id, 400, "Playlist ID is required");

      const verb = verbs[status];

      if (
        process.browser &&
        !confirm(`Are you sure you want to ${verb} this playlist?`)
      ) {
        return res.backDontScroll();
      }

      await api(`widget-store/${id}`, {
        method: "PUT",
        body: { status },
      });

      flash("success", `Successfully ${verb}ed`);

      res.refreshWith({}, { url: "back", hash: "#_" });
    });
};

export default Stores;
